import { REDUCER_NAME } from './const'

const NS = REDUCER_NAME + '/'

export const CHANGE_TABLE_SETTING = NS + 'CHANGE_TABLE_SETTING'

export const FIND_ALL_LEAD_REQUEST = NS + 'FIND_ALL_LEAD_REQUEST'
export const FIND_ALL_LEAD_SUCCESS = NS + 'FIND_ALL_LEAD_SUCCESS'
export const FIND_ALL_LEAD_ERROR = NS + 'FIND_ALL_LEAD_ERROR'

export const FIND_LEAD_REQUEST = NS + 'FIND_LEAD_REQUEST'
export const FIND_LEAD_SUCCESS = NS + 'FIND_LEAD_SUCCESS'
export const FIND_LEAD_ERROR = NS + 'FIND_LEAD_ERROR'

export const CHANGE_LEAD = NS + 'CHANGE_LEAD'

export const SAVE_LEAD_REQUEST = NS + 'SAVE_LEAD_REQUEST'
export const SAVE_LEAD_SUCCESS = NS + 'SAVE_LEAD_SUCCESS'
export const SAVE_LEAD_ERROR = NS + 'SAVE_LEAD_ERROR'

export const ADD_SENT_EMAIL = NS + 'ADD_SENT_EMAIL'




// WEBPACK FOOTER //
// ./src/modules/lead/state/type.js